// pages/Landing.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Landing.css';

const Landing = () => {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/register');
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="landing-container">
      {/* Cinematic Background */}
      <div className="cinematic-background">
        <img 
          src="assets/image.jpg" 
          alt="Cinematic Background" 
          className="cinematic-bg-image"
        />
        <div className="cinematic-overlay"></div>
        <div className="cinematic-glow"></div>
      </div>

      {/* Animated Elements */}
      <div className="animated-elements">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
        </div>
      </div>

      <main className="main-content">
        <div className="content-wrapper">
          <div className="text-section">
            <div className="cinematic-title-container">
              <div className="title-sequence">
                <h1 className="hero-welcome">WE ARE THE</h1>
                {/* <h1 className="hero-to">TO THE</h1> */}
                <div className="hero-main-titles">
                  <h1 className="hero-main">TINUBU-AMBODE</h1>
                  <h1 className="hero-subtitle">SUPPORTERS</h1>
                </div>
              </div>
              
              <div className="cinematic-tagline">
                <div className="tagline-decor left-decor"></div>
                <p className="tagline-text">United for Progress • Building Nigeria's Future</p>
                <div className="tagline-decor right-decor"></div>
              </div>
            </div>
          </div>
          
          <div className="image-section">
            <div className="cinematic-image-display">
              <div className="image-stage">
                <div className="image-glow-effect"></div>
                <img 
                  src="assets/image.jpg" 
                  alt="Tinubu and Ambode - Visionary Leadership" 
                  className="cinematic-image" 
                />
                <div className="image-shine"></div>
              </div>
              <div className="image-badge">
                <span className="badge-text">Visionary Leadership</span>
                <div className="badge-glow"></div>
              </div>
            </div>
          </div>
        </div>

        {/* Cinematic Action Buttons */}
        <div className="cinematic-action-buttons">
          <button 
            className="action-btn primary-btn"
            onClick={handleLoginClick}
          >
            <span className="btn-sparkle"></span>
            <span className="btn-label">Sign In</span>
            <span className="btn-arrow">→</span>
          </button>
          <button 
            className="action-btn secondary-btn"
            onClick={handleRegisterClick}
          >
            <span className="btn-icon">✓</span>
            <span className="btn-label">Register Now</span>
            <span className="btn-pulse"></span>
          </button>
        </div>

        {/* Scroll Indicator */}
        {/* <div className="scroll-indicator">
          <div className="scroll-line"></div>
          <span>Discover More</span>
        </div> */}
      </main>
    </div>
  );
};

export default Landing;